import { SERVICES } from "../../configs/constants";

export default {
  display: true,
  title: "Présence",
  contentType: "menu",
  canReduce: true,
  search: false,
  content: [
    {
      label: "Présence",
      icon: "pdc",
      id: "presence",
      component: "",
      path: "/presence/presence",
      onClick: "",
      minRole: 4,
      service: SERVICES.Presence
    },
    {
      label: "Congés",
      icon: "pdc",
      id: "conges",
      component: "",
      path: "/presence/conges",
      onClick: "",
      minRole: 4,
      service: SERVICES.Conges
    },
    {
      label: "NDF",
      icon: "pdc",
      id: "expenseReports",
      component: "",
      path: "/accouting/expenseReports",
      onClick: "",
      minRole: 4,
      // service: SERVICES.NDF
    },
    {
      label: "Virements",
      icon: "pdc",
      id: "transfers",
      component: "",
      path: "/accouting/transfers",
      onClick: "",
      minRole: 3,
      service: SERVICES.Virement
    },
    {
      label: "Gestion des primes",
      icon: "premium",
      id: "premium",
      component: "",
      path: "/bonuses",
      onClick: "",
      submenu: false,
      minRole: 3,
      service: SERVICES.Primes
    },

    {
      label: "Historique des primes",
      icon: "bonus",
      id: "bonushistory",
      component: "",
      path: "/presence/bonuseshistory",
      onClick: "",
      submenu: false,
      minRole: 3,
      service: SERVICES.Primes
      // service: SERVICES.Privileges
    },
    // {
    //   label: "Tableau primes",
    //   icon: "premium",
    //   id: "premium",
    //   component: "",
    //   path: "/presence/bonuses",
    //   onClick: "",
    //   submenu: false,
    //   minRole: 3
    //   // service: SERVICES.Privileges
    // },
    // {
    //   label: "Primes normales",
    //   icon: "regular",
    //   id: "regular",
    //   component: "",
    //   path: "/presence/regular",
    //   onClick: "",
    //   minRole: 1
    // },
    {
      label: "Gestion plafond",
      icon: "limit",
      id: "limit",
      component: "",
      path: "/presence/limit",
      onClick: "",
      minRole: 2,
      service: SERVICES.Primes
    },
    {
      label: "Primes exceptionnelles",
      icon: "extrapremium",
      id: "extrapremium",
      component: "",
      path: "/presence/premium",
      onClick: "",
      submenu: false,
      minRole: 2,
      service: SERVICES.Primes
      // service: SERVICES.Privileges
    }
  ]
};



// WEBPACK FOOTER //
// src/pages/presence/Menu.js